import script from "./AccountRecoveryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountRecoveryView.vue?vue&type=script&setup=true&lang=js"

import "./AccountRecoveryView.vue?vue&type=style&index=0&id=8869d01c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8869d01c"]])

export default __exports__